var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42705 13.2315C9.20305 13.2315 8.97905 13.1475 8.80616 12.9789L4.3515 8.63199C4.18016 8.46488 4.0835 8.23533 4.0835 7.99577C4.0835 7.75621 4.18016 7.52688 4.3515 7.35955L8.7975 3.02133C9.14905 2.67866 9.7115 2.68533 10.0546 3.03666C10.3973 3.38799 10.3906 3.95088 10.0393 4.29355L6.24505 7.99577L10.0479 11.7064C10.3993 12.0491 10.4059 12.612 10.0633 12.9633C9.88927 13.1418 9.65816 13.2315 9.42705 13.2315Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.678e8b342e9c2f63cb92fbf85c61dd78.svg";
export { ForwardRef as ReactComponent };